import { render, staticRenderFns } from "./ProjectValuationSnapshotVersionSelect.vue?vue&type=template&id=42c94e1a&"
import script from "./ProjectValuationSnapshotVersionSelect.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationSnapshotVersionSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSelect,VSpacer})
